import React from 'react';
import moment from 'moment';
import { CSVLink } from "react-csv";
import { useIntl } from 'react-intl';
import {toNativeDate} from "../../Function/globalFunction";

export default function GenerateCSV({ csvData, fromDate, toDate }) {
    const intl = useIntl();
    const [filename, setFilename] = React.useState('');

    React.useEffect(() => {
        let fromDisplayDate = moment(toNativeDate(fromDate)).format(window.global.momentFormat);
        let toDisplayDate = moment(toNativeDate(toDate)).format(window.global.momentFormat);
        setFilename('ApprovalHistory_' + fromDisplayDate + '_To_' + toDisplayDate + '.csv');
    }, [fromDate, toDate]);

    const headers = [
        { label: 'ID', key: "id" },
        { label: intl.formatMessage({ id: 'leave_approval.staff_number' }), key: "staffNo" },
        { label: intl.formatMessage({ id: 'leave_approval.employee' }), key: "employeeName" },
        { label: intl.formatMessage({ id: 'leave_approval.position' }), key: "position" },
        { label: intl.formatMessage({ id: 'leave_approval.location' }), key: "location" },
        { label: intl.formatMessage({ id: 'leave_approval.department' }), key: "department" },
        { label: intl.formatMessage({ id: 'new_application.leave_type' }), key: "type" },
        { label: intl.formatMessage({ id: 'table.date_approved' }), key: "dateApproved" },
        { label: intl.formatMessage({ id: 'table.date_submitted' }), key: "dateSubmitted" },
        { label: intl.formatMessage({ id: 'common.from' }), key: "startDate" },
        { label: intl.formatMessage({ id: 'common.to' }), key: "untilDate" },
        { label: intl.formatMessage({ id: 'new_application.taken' }), key: "period" },
        { label: intl.formatMessage({ id: 'table.status' }), key: "approveStatus" },
        { label: intl.formatMessage({ id: 'comment' }), key: "approvalComment" },
    ];

    return (
        <div>
            {filename ?
                <CSVLink filename={filename} data={csvData} headers={headers}>
                    <div style={{ color: '#000', opacity: '0.87' }}>{intl.formatMessage({ id: 'leave_approval.export' })}</div>
                </CSVLink>
                :
                null
            }
        </div>
    );
}